var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"panel-content"},[(_vm.description)?_c('p',{staticClass:"description m-b-30"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }